import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as authAPI from '@debbie/cortex/dist/api/auth.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Input } from '../../index.js';
const Reset = (props) => {
    const lang = useSelector((s) => s.lang);
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');
    const trimmedUsername = username.trim();
    const reset = useMutation(() => authAPI.initiatePasswordReset(trimmedUsername), {
        onSuccess: () => {
            props.onReset(trimmedUsername);
        },
        onError: (err) => {
            console.error(err);
            setError(err?.message);
        },
    });
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => {
                console.log(e);
                e.preventDefault();
                e.stopPropagation();
                reset.mutate();
            } },
            error !== '' ? React.createElement("div", { className: "warning" }, error) : null,
            React.createElement(Input, { placeholder: lang.login.email, value: username, onChange: (e) => {
                    setUsername(e.target.value);
                } }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' }, loading: reset.isLoading }, lang.login.reset),
            React.createElement(Button, { block: true, onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onCancel();
                }, theme: "secondary" }, lang.misc.cancel))));
};
export default Reset;
//# sourceMappingURL=Reset.js.map